export default __webpack_public_path__ + "e15889a9fdc23065bfa7385d8bbfb86f.png";